import { useTheme } from '@mui/material'
import { GridFilterModel, GridSortModel, useGridApiRef } from '@mui/x-data-grid-premium'
import { useUserItems } from 'api/aws/users/useUserItems'
import { useTimeline } from 'api/aws/useTimeline'
import { renderTimelineColumns } from 'components/DataGrid/createColumns/renderTimelineColumns'
import GlobalDataGrid from 'components/DataGrid/GlobalDataGrid'
import { useLayoutContext } from 'context/LayoutProvider/LayoutProvider'
import * as React from 'react'
import { useParams } from 'react-router-dom'
import { Timeline } from 'types'

const defaultSortModel: GridSortModel = [{ field: 'timestamp', sort: 'asc' }]
const defaultFilterModel: GridFilterModel = {
  items: [],
  quickFilterValues: [],
}

const TimelinePage: React.FC = () => {
  const { PK, SK } = useParams()
  const dealId = SK?.split('DEAL_')?.[1]
  const { pinned } = useLayoutContext()
  const theme = useTheme()
  const { timeline = [], isLoading } = useTimeline(dealId)
  const { data: users } = useUserItems()
  const apiRef = useGridApiRef()
  console.log('timeline', timeline)
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({ items: [] })
  const timelineRows = React.useMemo(() => {
    if (!timeline || isLoading) return []
    return (timeline ?? [])?.map(t => ({ ...t, rowId: `${t?.timeline_uuid}-${t?.timestamp}` })) as Timeline[]
  }, [timeline, isLoading])
  const columns = React.useMemo(() => renderTimelineColumns(users), [users])

  // keep “visible rows count” if you still need it
  React.useEffect(() => {
    const handle = () => {
      const lookup = apiRef.current.state.filter.filteredRowsLookup
      // if you need it: const count = Object.values(lookup).filter(Boolean).length
    }
    const api = apiRef.current
    const unsub = api.subscribeEvent('filterModelChange', handle)
    handle()
    return () => unsub()
  }, [apiRef])
  const gridContainerSx = {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    pb: 2,
    transition: 'all 0.3s ease-in-out',
    height: '100%',
    flex: 1,
  }
  return (
    <GlobalDataGrid
      apiRef={apiRef}
      rows={timelineRows}
      columns={columns}
      context="timeline"
      defaultFilterModel={defaultFilterModel}
      defaultVisibilityModel={{}}
      defaultSortModel={defaultSortModel}
      defaultGridDensity="standard"
      treeData={false}
      gridContainerSx={gridContainerSx}
      checkboxSelection={false}
    />
  )
}

export default TimelinePage
